// extracted by mini-css-extract-plugin
module.exports = {"container":"user_container__3oO_9","image":"user_image__SA5gq","middle":"user_middle__1t9xE"};